import { formatDataBr } from "@/modules/recursos";
import { useMemo, useState } from "react";
import { useObraEmbarcacaoInformacoes, useObraPeriodos } from "@/modules/obras";
import { calcularCronograma, readDuracao } from "../../../hooks/nova-obra.duracao";
import { periodoDaObraNoWizard } from "../../../hooks/nova-obra.equipe";
import { useNovaObra } from "../../../hooks/nova-obra.context";
import { REVISAO } from "../../../nova-obra.constants";
import type { SecaoDuracaoProps } from "./types-secao-duracao";

export function useSecaoDuracao({ onEditar }: SecaoDuracaoProps) {
  const { state } = useNovaObra();
  const periodos = useObraPeriodos();
  const informacoes = useObraEmbarcacaoInformacoes(state.obra.embarcacaoId);
  const [verLimites, setVerLimites] = useState(false);
  const dados = useMemo(() => readDuracao(state.etapas.duracao), [state.etapas.duracao]);
  const cronograma = useMemo(() => calcularCronograma(dados), [dados]);
  const periodoWizard = useMemo(
    () => periodoDaObraNoWizard(state.etapas.duracao),
    [state.etapas.duracao],
  );

  const embarcacaoId = state.obra.embarcacaoId;
  const abrirLimites = () => setVerLimites(true);
  const fecharLimites = () => setVerLimites(false);

  return {
    embarcacaoId,
    periodos,
    informacoes,
    verLimites,
    abrirLimites,
    fecharLimites,
    dados,
    cronograma,
    periodoWizard,
    onEditar,
    inicioFormatado: formatDataBr(cronograma.inicio ?? ""),
    terminoPrevistoFormatado: formatDataBr(cronograma.terminoPrevisto ?? ""),
    duracaoTotalFormatada:
      cronograma.duracaoTotal === null
        ? REVISAO.vazio
        : REVISAO.duracao.dias(cronograma.duracaoTotal),
  };
}
